import React from 'react'
import Icon from './icon'

const Bubble = () => {
  return (
    <Icon>
      <path d="M0 0h24v24H0z" fill="none" />
      <circle cx="7.2" cy="14.4" r="3.2" />
      <circle cx="14.8" cy="18" r="2" />
      <circle cx="15.2" cy="8.8" r="4.8" />
    </Icon>
  )
}

export default Bubble



// WEBPACK FOOTER //
// ./src/components/Icons/bubble.js